export enum PaymentProviderName {
  PayPal = 'paypal',
  Checkout = 'checkout',
  Confirmo = 'confirmo',
  Fibonatix = 'fibonatix',
  PaySafe = 'paysafe',
  Free = 'free',
  UpiIndia = 'upiIndia',
  HubCredits = 'hubCredits',
  Paytiko = 'paytiko',
  Mock = 'mock',
}

export enum SupportedCurrencies {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  INR = 'INR',
}

// in paysafe big currencies need to be in their smallest unit for example 10 dollars should pass in amount to paysafe 1000
// Todo: add tests
export const paySafeAmountByCurrency = (
  amount: number,
  currency: SupportedCurrencies,
  returnedFromPaysafe?: boolean,
) => {
  if (
    [
      SupportedCurrencies.USD,
      SupportedCurrencies.EUR,
      SupportedCurrencies.GBP,
      SupportedCurrencies.INR,
    ].includes(currency)
  ) {
    if (returnedFromPaysafe) {
      return amount / 100;
    } else {
      amount = amount * 100;
    }
  }

  return Math.round(amount);
};

export type CurrencyRates = Record<SupportedCurrencies, number>;
